/** Live SFUT Legacy ApertumNFTv2 proxy on Apertum 2786. */
export const SFUT_LEGACY_COLLECTION =
  '0x0F7585B67b4ada5508fA361d638B7Ce65F9914B9';

/** OpenPlaza partner gallery — mint and wallet stay on OpenPlaza. */
export const SFUT_LEGACY_GALLERY_URL =
  'https://openplaza.io/partners/sportsfuture/gallery';

/** OpenPlaza partner page — mint lives there, not on SportsFuture. */
export const SFUT_LEGACY_MINT_URL =
  'https://openplaza.io/partners/sportsfuture/';

export const SFUT_LEGACY_EXPLORER_INSTANCES_URL = `https://explorer.apertum.io/api/v2/tokens/${SFUT_LEGACY_COLLECTION}/instances`;
